import { Box, VStack, Text, Icon } from '@chakra-ui/react';
import LogoWordmark from '@m/assets/svg/logo-wordmark';

import ConeIcon from './ConeIcon';

export default function MaintenancePage() {
  return (
    <VStack
      // Use position fixed with a white background
      // to cover up any loading or error handling content.
      position="fixed"
      top="0"
      left="0"
      width="100vw"
      height="100vh"
      backgroundColor="white"
      zIndex="9999"
    >
      <Box py="6">
        <LogoWordmark />
      </Box>

      <Icon as={ConeIcon} width="60px" height="100px" pb="6" />

      <VStack maxWidth="375px" gap="4" px="4">
        <Box>
          <Text variant="Subheader" color="text.primary" mb="8px">
            System upgrade in progress
          </Text>
          <Text variant="SmallBody" color="text.secondary">
            You can continue parking as usual. We're performing an important upgrade to improve your
            experience. Your activity will be fully recorded and unaffected.
          </Text>
        </Box>
        <Box>
          <Text variant="SmallBody" color="text.secondary">
            If you need help, please contact customer support at (856) 485-9703.
          </Text>
        </Box>
      </VStack>
    </VStack>
  );
}
